export default "__VITE_ASSET__CKzf_ChF__"